import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { CopyrightCheckerStatus } from '../../../interfaces/CopyrightCheckerStatus';
import * as styled from './StatusIndicator.style';
function StatusIndicator({ status, label }) {
    const { t } = useTranslation();
    return (_jsxs(styled.Container, { children: [_jsx(styled.Circle, { status, 'aria-hidden': true }), label ? label : t(`copyright_checker.dossier.statuses.${status}`)] }));
}
StatusIndicator.Status = CopyrightCheckerStatus;
export default StatusIndicator;
